import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import SmartSearchEditor from '../components/crosstab/SmartSearchEditor';
// import DictionarySearchEditor from '../components/crosstab/DictionarySearchEditor';
import {
  DICTIONARY_SEARCH_CLICK,
  SMART_SEARCH_CLICK,
  CROSSTAB_FEATUREID,
  CROSSTAB_RUN_REPORT_DS,
  FLEX_STUDY_TAG,
  AUTOCODE_RUN_BTN_CLICK,
  AUTOCODE_STUDY_CHANGE_EVENT,
} from '../constants';
import DataHaulSmartSearchEditor from '../components/datahaul/DataHaulSmartSearchEditor';
import DictionarySearchV2 from '../components/dictionary/DictionarySearchV2';
import Autocode from '../components/autocode/Autocode';
import AutocodeBackButton from '../components/autocode/AutocodeBackButton';
import GenericButton from '../components/common/GenericButton';
import * as studyActions from '../actions/studyActions';
import * as crosstabActions from '../actions/crosstabActions';
import { GEOGRAPHY_BASES } from '../actions/actionTypes';
import AutocodeRunButton from '../components/autocode/AutocodeRunButton';
import AutocodeCRBGrid from '../components/autocode/AutocodeCRBGrid';
import { CT1_CO1, CO1_RUN_REPORT, CO1_CT1 } from '../trackerConstants';
import Modal from '../components/common/Modal/Modal';

const modalQuadWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

class CrosstabEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSmartSearchSelected: props.isSmartSearchSelected === 'Smart Search',
      autocodeSelected: false,
    };
    this.smartSearchEditor = React.createRef();
    this.dictionarySearchEditor = React.createRef();
    this.dhSmartSearchEditor = React.createRef();
  }

  componentDidMount() {
    if (window.location.search && window.location.search === '?composer=1') {
      this.setState({ autocodeSelected: true });
    }
    this.onMount();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.isSmartSearchSelected &&
      nextProps.isSmartSearchSelected !== this.props.isSmartSearchSelected &&
      !nextProps.dataScreen
    ) {
      this.setState(
        {
          isSmartSearchSelected:
            nextProps.isSmartSearchSelected === 'Smart Search',
        },
        () => {
          if (!this.state.isSmartSearchSelected) {
            this.props.handlesideBarToggle();
          }
        }
      );
    }
    if (window.location && window.location.search === '?composer=1') {
      this.setState({ autocodeSelected: true });
    } else {
      this.setState({ autocodeSelected: false });
    }
  }

  onMount = () => {
    if (!this.props.dataScreen) {
      if (!this.state.isSmartSearchSelected && !this.props.dataScreen) {
        this.props.handlesideBarToggle();
      }
    } else {
      this.setState({ isSmartSearchSelected: true });
    }
  };

  getSelectedEditor = () => this.state.isSmartSearchSelected;

  getCrosstabTitle = () =>
    this.smartSearchEditor && this.smartSearchEditor.current
      ? this.smartSearchEditor.current.getCrosstabTitle()
      : 'untitled';

  // method to be called from build new Data enablement to come to dictionary search page.
  setDictionarySearchView = isSmartSearch => {
    this.setState({ isSmartSearchSelected: isSmartSearch }, () =>
      this.props.cdDictionarySearchOpened(!isSmartSearch)
    );
  };

  toggleSearchEditor = () => {
    if (this.state.isSmartSearchSelected) {
      this.props.trackerFn({ action: DICTIONARY_SEARCH_CLICK });
    } else {
      this.props.trackerFn({ action: SMART_SEARCH_CLICK });
    }
    this.setState(
      { isSmartSearchSelected: !this.state.isSmartSearchSelected },
      () =>
        this.props.cdDictionarySearchOpened(!this.state.isSmartSearchSelected)
    );
  };

  toggleAutocode = autoCodeState => {
    if (autoCodeState) {
      browserHistory.push('/essentials/crosstab?composer=1');
    } else if (this.props.crosstabTableList && (this.props.crosstabTableList[0].viewerGridType === 'Quad' 
    && this.props.ColumnsDataGridData.length < 2)) {
        this.warningQuadModal.show();
      } else {
        browserHistory.push('/essentials/crosstab');
      }
      if (!(this.props.crosstabTableList && (this.props.crosstabTableList[0].viewerGridType === 'Quad' 
      && this.props.ColumnsDataGridData.length < 2))) {
        this.setState({ autocodeSelected: !this.state.autocodeSelected });
        if (autoCodeState) {
          this.props.handleScreenSelection('autocode');
          this.props.trackerFn({ action: CT1_CO1 });
        } else {
          this.props.handleScreenSelection('');
          this.props.runCrosstab();
          this.props.trackerFn({ action: CO1_CT1 });
          this.props.trackerFn({ action: CO1_RUN_REPORT });
        }
      }
  };

  crosstabAutocodeRun = () => {
    this.toggleAutocode('');
  };

  toggleCrosstabView = isViewScreenSelected => {
    if (isViewScreenSelected) {
      this.setState({ isSmartSearchSelected: true }, () =>
        this.smartSearchEditor.current.toggleCrosstabView(isViewScreenSelected)
      );
    } else {
      this.smartSearchEditor.current.toggleCrosstabView(isViewScreenSelected);
    }
  };

  handleCrosstabEdit = (idKey, dataSmartSearch, keyword) => {
    if (dataSmartSearch) {
      if (this.props.dataScreen !== 'DataHaul') {
        if (this.smartSearchEditor) {
          this.smartSearchEditor.current.handleCrosstabEdit(
            idKey,
            dataSmartSearch
          );
        } else {
          this.setState({ isSmartSearchSelected: true }, () =>
            this.smartSearchEditor.current.handleCrosstabEdit(
              idKey,
              dataSmartSearch
            )
          );
        }
      } else if (this.props.dataScreen === 'DataHaul') {
        if (this.smartSearchEditor) {
          this.dhSmartSearchEditor.handleCrosstabEdit(idKey, dataSmartSearch);
        } else {
          this.setState({ isSmartSearchSelected: true }, () =>
            this.dhSmartSearchEditor.handleCrosstabEdit(idKey, dataSmartSearch)
          );
        }
      }
    } else if (this.smartSearchEditor) {
      this.setState({ isSmartSearchSelected: false }, () =>
        this.dictionarySearchEditor.current.handleCrosstabEditToDictionary(
          idKey,
          dataSmartSearch,
          keyword
        )
      );
    } else {
      this.dictionarySearchEditor.current.handleCrosstabEditToDictionary(
        idKey,
        dataSmartSearch,
        keyword
      );
    }
  };

  handleProbabilitiesEditClick = (rowData, colData) => {
    this.setState({ isSmartSearchSelected: false }, () =>
      this.dictionarySearchEditor.current.handleProbabilitiesEditClick(
        rowData,
        colData
      )
    );
  };

  updateModuleStudy = study => {
    this.props.studyActions.updateModuleStudy('crosstab', study);
  };

  handleRunCrosstab = () => {
    this.toggleSearchEditor();
    this.props.runCrosstab();
    this.props.trackerFn({ action: CROSSTAB_RUN_REPORT_DS });
  };

  changeViewType = () => {
    this.toggleSearchEditor();
    this.props.changeViewType();
  };

  resetSmarchSearch = () =>
    this.smartSearchEditor &&
    this.smartSearchEditor.current.resetSmarchSearch();

  isRunEnabled = () => {
    if (
      this.props.crosstabStudy &&
      !this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (
        (this.props.gridData.RowsDataGrid &&
          this.props.gridData.RowsDataGrid.length > 0) ||
        (this.props.gridData.ColumnsDataGrid &&
          this.props.gridData.ColumnsDataGrid.length > 0)
      ) {
        return true;
      }
      return false;
    }
    if (
      this.props.crosstabStudy &&
      this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (
        this.props.gridData.BasesDataGrid &&
        this.props.gridData.BasesDataGrid.length > 0 &&
        ((this.props.gridData.RowsDataGrid &&
          this.props.gridData.RowsDataGrid.length > 0) ||
          (this.props.gridData.ColumnsDataGrid &&
            this.props.gridData.ColumnsDataGrid.length > 0))
      ) {
        let geoBaseCnt = 0;
        this.props.gridData.BasesDataGrid.forEach(crosstabBase => {
          GEOGRAPHY_BASES.forEach(geoBase => {
            if (crosstabBase.keyword.includes(geoBase)) {
              geoBaseCnt += 1;
            }
          });
        });
        if (geoBaseCnt > 0) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  };

  handleStudyChangeEvent = (val, updatedWeightType) => {
    this.props.handleStudyChange(val, updatedWeightType);
    this.props.trackerFn({ action: AUTOCODE_STUDY_CHANGE_EVENT });
  };

  renderSearchEditor = () => {
    if (this.state.autocodeSelected) {
      return (
        <Autocode
          studies={this.props.studies}
          featureID={CROSSTAB_FEATUREID}
          defaultStudy={this.props.crosstabStudy}
          alertMsg="This selection will impact all of the Crosstab modules"
          showWeightType
          selectedWeightType={this.props.crosstabWeightTypes}
          gridData={this.props.gridData}
          menuName="crosstab"
          handleStudyChange={this.handleStudyChangeEvent}
          runReport={this.props.runAfterWeightChange}
          uid={this.props.uid}
          trackerFn={this.props.trackerFn}
          moduleAction={this.props.crosstabActions}
          BasesDataGridData={this.props.BasesDataGridData}
          ColumnsDataGridData={this.props.ColumnsDataGridData}
          RowsDataGridData={this.props.RowsDataGridData}
          ScratchDataGridData={[]}
          showAddSaveDefinitionBtn
          showBulkJoinBtn
          showCRBBtns
          rightSideClass="autocode-right-col"
          canAddNewFolders
          showTargetEllipsis
          canAddNewDefinitions
          showDefFolderEllipsis
          showDefEditBtn
          toggleDragDrop
          showSmplWghtDisplay
        >
          <AutocodeBackButton
            title="Back To Crosstab"
            toggleAutocode={this.toggleAutocode}
          />
          <AutocodeCRBGrid
            gridTitle="Report Preview"
            BasesDataGridData={this.props.BasesDataGridData}
            ColumnsDataGridData={this.props.ColumnsDataGridData}
            RowsDataGridData={this.props.RowsDataGridData}
            moduleAction={this.props.crosstabActions}
            weightTypes={this.props.crosstabWeightTypes}
            moduleStudy={this.props.crosstabStudy}
            gridData={this.props.gridData}
            selectedWeightType={this.props.crosstabWeightTypes}
            activeAccountId={this.props.activeAccountId}
            uid={this.props.uid}
            sampleWeightedKPIs={this.props.sampleWeightedKPIs}
            partsToShow={this.props.partsToShow}
          />
          <AutocodeRunButton
            title="Run Report"
            isRunEnabled={this.isRunEnabled()}
            autocodeRun={this.crosstabAutocodeRun}
          />
        </Autocode>
      );
    }

    if (this.state.isSmartSearchSelected && !this.props.dataScreen) {
      return (
        <SmartSearchEditor
          toggleAutocode={this.toggleAutocode}
          toggleSearchEditor={this.toggleSearchEditor}
          crosstabStudy={this.props.crosstabStudy}
          datahaulStudy={this.props.datahaulStudy}
          fetchKPI={this.props.fetchKPI}
          getSampleWeighted={this.props.getSampleWeighted}
          gridData={this.props.gridData}
          cellElementList={this.props.cellElementList}
          runCrosstab={this.props.runCrosstab}
          runDataHaul={this.props.runDataHaul}
          dataScreen={this.props.dataScreen}
          ref={this.smartSearchEditor}
          stopSpinner={this.props.stopSpinner}
          trackerFn={this.props.trackerFn}
          handleStudyChange={this.props.handleStudyChange}
          hideWeightType={this.props.hideWeightType}
          selectedBase={this.props.selectedBase}
          runAfterWeightChange={this.props.runAfterWeightChange}
          handleSaveCrosstab={this.props.handleSaveCrosstab}
          handleProbabilitiesEditClick={this.handleProbabilitiesEditClick}
        />
      );
    }
    if (this.props.dataScreen === 'DataHaul') {
      return (
        <DataHaulSmartSearchEditor
          datahaulStudy={this.props.datahaulStudy}
          fetchKPI={this.props.fetchKPI}
          getSampleWeighted={this.props.getSampleWeighted}
          gridData={this.props.gridData}
          runDataHaul={this.props.runDataHaul}
          dataScreen={this.props.dataScreen}
          ref={node => (this.dhSmartSearchEditor = node)}
          trackerFn={this.props.trackerFn}
          handleStudyChange={this.props.handleStudyChange}
          hideWeightType={this.props.hideWeightType}
        />
      );
    }
    return (
      <DictionarySearchV2
        toggleSearchEditor={this.toggleSearchEditor}
        moduleStudy={this.props.crosstabStudy}
        studies={this.props.studies}
        runCrosstab={this.props.runCrosstab}
        gridData={this.props.gridData}
        ref={this.dictionarySearchEditor}
        trackerFn={this.props.trackerFn}
        dataScreen={this.props.dataScreen}
        handleStudyChange={this.props.handleStudyChange}
        hideWeightType={this.props.hideWeightType}
        runReport={this.props.runAfterWeightChange}
        weightTypes={this.props.crosstabWeightTypes}
        BasesDataGridData={this.props.BasesDataGridData}
        ColumnsDataGridData={this.props.ColumnsDataGridData}
        RowsDataGridData={this.props.RowsDataGridData}
        ScratchDataGridData={this.props.ScratchDataGridData}
        updateModuleStudy={this.updateModuleStudy}
        sampleWeightedKPIs={this.props.sampleWeightedKPIs}
        recycleElements={this.props.recycleElements}
        rightGridList={['crb', 'scratch']}
        dictionaryTabsList={[
          'dictionary',
          'geography',
          'definition',
          'recycle',
        ]} // [] in case all tabs to be hidden
        noExpressionBox={false} // true in case expression box is not being used
        featureID={CROSSTAB_FEATUREID}
        alertMsg="This selection will impact all of the Crosstab modules"
        menuName="DictionarySearch"
        moduleAction={this.props.crosstabActions}
        handleRun={this.handleRunCrosstab}
        mainMenuName="Essentials"
        moduleName="Crosstab"
        backBtnLabel="Smart Search"
        backBtnAction={this.changeViewType}
        functionProbabilitiesFlag
        breadcrumbFlag
        rowColBaseGrid
        isRunEnabled={this.isRunEnabled()}
        useQuestions={this.props.useQuestions}
        partsToShow={this.props.partsToShow}
      />
    );
  };

  render() {
    return <div>
      <Modal
            title=""
            ref={node => (this.warningQuadModal = node)}
            dialogStyles={modalQuadWariningStyle}
          >
            <div className="text-center">
              <p>
                Please add at least 2 columns and click run to see Quad Chart.
              </p>
              <GenericButton
                name="Ok"
                btnStyle="button btn-cncl button-125px"
                onBtnClick={() => this.warningQuadModal.hide()}
              />
            </div>
          </Modal>
      {this.renderSearchEditor()}
      </div>;
  }
}

CrosstabEditor.propTypes = {
  crosstabStudy: PropTypes.shape({
    st: PropTypes.string,
  }),
  datahaulStudy: PropTypes.shape({}),
  cellElementList: PropTypes.arrayOf(PropTypes.object),
  getSampleWeighted: PropTypes.func,
  fetchKPI: PropTypes.func,
  gridData: PropTypes.shape({
    BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
    ColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    RowsDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
  runCrosstab: PropTypes.func,
  runDataHaul: PropTypes.func,
  stopSpinner: PropTypes.func,
  cdDictionarySearchOpened: PropTypes.func,
  dataScreen: PropTypes.string,
  trackerFn: PropTypes.func,
  isSmartSearchSelected: PropTypes.string,
  handlesideBarToggle: PropTypes.func,
  handleStudyChange: PropTypes.func,
  hideWeightType: PropTypes.bool,
  selectedBase: PropTypes.string,
  runAfterWeightChange: PropTypes.func,
  changeViewType: PropTypes.func,
  handleSaveCrosstab: PropTypes.func,
  studies: PropTypes.arrayOf(PropTypes.object),
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
  }),
  ScratchDataGridData: PropTypes.arrayOf(PropTypes.object),
  ColumnsDataGridData: PropTypes.arrayOf(PropTypes.object),
  BasesDataGridData: PropTypes.arrayOf(PropTypes.object),
  RowsDataGridData: PropTypes.arrayOf(PropTypes.object),
  crosstabWeightTypes: PropTypes.shape({}),
  sampleWeightedKPIs: PropTypes.shape({}),
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  handleScreenSelection: PropTypes.func,
  activeAccountId: PropTypes.number,
  partsToShow: PropTypes.shape({}),
  uid: PropTypes.number,
  useQuestions: PropTypes.bool,
  crosstabTableList: PropTypes.arrayOf(PropTypes.object),

};

function mapStateToProps(state) {
  return {
    crosstabWeightTypes: state.study.crosstabWeightTypes,
    crosstabStudy: state.study.crosstabStudy,
    BasesDataGridData: state.crosstab.BasesDataGridData,
    ColumnsDataGridData: state.crosstab.ColumnsDataGridData,
    RowsDataGridData: state.crosstab.RowsDataGridData,
    ScratchDataGridData: state.crosstab.ScratchDataGridData,
    sampleWeightedKPIs: state.crosstab.sampleWeightedKPIs,
    recycleElements: state.crosstab.RecycleGridData,
    partsToShow: state.crosstab.partsToShow,
    useQuestions: state.crosstab.useQuestions,
    crosstabTableList: state.crosstab.crosstabTableList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(CrosstabEditor);
